import React from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import ModalCloseButton from './ModalCloseButton';
import { ModalProps } from './ModalProps';

interface Props extends ModalProps {
  hideCloseButton?: boolean;
  maxWidth?: number;
  className?: string;
}

const Layout = styled.section<Partial<Props>>`
  position: relative;
  z-index: ${theme.zIndex.modal + 2};
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  max-width: ${({ maxWidth }) => (maxWidth ? toRem(maxWidth) : toRem(420))};
  height: auto;
  margin: ${toRem(theme.layout.gutter.small)} 0;
  padding: ${toRem(theme.modal.spacing.small)};
  border-radius: ${toRem(22)};
  background-color: ${theme.color.white};
  box-shadow: ${theme.shadow.modal};

  @media (min-width: ${theme.breakpoint.small}px) {
    margin: ${toRem(theme.layout.gutter.large)} 0;
    padding: ${toRem(theme.modal.spacing.large)};
  }

  ${({ sticky }) =>
    sticky &&
    css`
      height: auto;
      max-height: 100%;
      margin: 0;
      overflow: hidden;

      @media (min-width: ${theme.breakpoint.med}px) {
        max-height: ${toRem(600)};
        margin: 0;
        padding: 0 ${toRem(44)};
      }
    `}
`;

const ModalLayout: React.FC<Props> = ({ onClose, hideCloseButton, isActive, sticky, maxWidth, children, className, ...rest }) => (
  <Layout isActive={isActive} sticky={sticky} maxWidth={maxWidth} className={className} {...rest}>
    {!hideCloseButton && <ModalCloseButton sticky={sticky} onClick={onClose} />}
    {children}
  </Layout>
);

export default ModalLayout;
